import { Component, OnInit, ViewEncapsulation, AfterViewInit, ViewChild, ElementRef, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiContentService } from '../../api/api-content.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MapsAPILoader, MouseEvent } from '@agm/core';

@Component({
  selector: 'app-regisnew',
  templateUrl: './regisnew.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./regisnew.component.css'],
  styles: [`
    .light-blue-backdrop {
      background-color: #5cb3fd;
    }
  `]
})
export class RegisnewComponent implements OnInit {
  
  constructor(
    private route:ActivatedRoute,
		public rest:ApiContentService,
    private fb: FormBuilder,  
    private router: Router,
    private modalService: NgbModal,
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone
  ) { }

  registerForm: FormGroup;
  submitted = false;
  refid = '';
  loadingIcon = {
    invalid: false
  };
  regis:any = [];
  provinces:any = [];
  cities:any = [];
  districts:any = [];
  subdistricts:any = [];

  ngOnInit(): void {
    this.refid = this.route.snapshot.params.refid
    // console.log(this.refid);
    this.checkAccount(this.refid);
    
    this.registerForm = this.fb.group({
      accountidreferral: [''],
      namereferral: [''],
      name: [''],
      address: [''],
      home_number: [''],
      province: [''],
      city: [''],
      district: [''],
      subdistrict: [''],
      rw: [''],
      rt: [''],
      postal_code: ['', Validators.minLength(5)],
      email: ['', Validators.email],
      phone_number: ['', Validators.minLength(10)]
    });

    // this.setCurrentLocation();

    //load Places Autocomplete
    this.mapsAPILoader.load().then(() => {
      this.setCurrentLocation();
      // this.geoCoder = new google.maps.Geocoder;

      // let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
      //   types: ["address"]
      // });
      // autocomplete.addListener("place_changed", () => {
      //   this.ngZone.run(() => {
      //     //get the place result
      //     let place: google.maps.places.PlaceResult = autocomplete.getPlace();

      //     //verify result
      //     if (place.geometry === undefined || place.geometry === null) {
      //       return;
      //     }

      //     //set latitude, longitude and zoom
      //     this.latitude = place.geometry.location.lat();
      //     this.longitude = place.geometry.location.lng();
      //     this.zoom = 12;
      //   });
      // });
    });
  }

  get f(){
    return this.registerForm.controls;
  }

  checkAccount(accountid:any){
    // console.log(accountid);
    const params = {
      'accountid' : accountid
    }
    this.rest.checkAccount(params).subscribe((response:any) => {
      // console.log(this.regis,response.data);
      // console.log(response.data);
      if (response.status) {
        this.loadingIcon.invalid = false;

        this.regis = response.data;
        this.getProvince();

      }else{

        this.loadingIcon.invalid = true;
        
      }
    });
  }

  getProvince(){
    const params = {
      'country_id': 1,
      'show': 'all'
    }
    this.rest.getProvince(params).subscribe((response:any) => {
      // console.log(response);f
      if (response.status) {

        this.provinces = response.data;

      }
    });
  }

  getCity(provinceid:any){
    const params = {
      'province_id': provinceid,
      'show': 'all'
    }
    this.rest.getCity(params).subscribe((response:any) => {
      // console.log(response);
      if (response.status) {

        this.cities = response.data;

      }
    });
  }

  getDistrict(cityid:any){
    const params = {
      'city_id': cityid,
      'show': 'all'
    }
    this.rest.getDistrict(params).subscribe((response:any) => {
      // console.log(response);
      if (response.status) {

        this.districts = response.data;

      }
    });
  }

  getSubdistrict(districtid:any){
    const params = {
      'district_id': districtid,
      'show': 'all'
    }
    this.rest.getSubdistrict(params).subscribe((response:any) => {
      console.log(response);
      if (response.status) {

        this.subdistricts = response.data;

      }
    });
  }

  // ------- v3 -------
  title: string = 'AGM project';
  latitude: number;
  longitude: number;
  zoom: number;
  address: string;
  // private geoCoder;
 
  @ViewChild('search')
  public searchElementRef: ElementRef;

  // Get Current Location Coordinates
  private setCurrentLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        this.zoom = 8;
        // this.getAddress(this.latitude, this.longitude);
      });
    }
  }


  markerDragEnd($event: MouseEvent) {
    console.log($event);
    this.latitude = $event.coords.lat;
    this.longitude = $event.coords.lng;
    // this.getAddress(this.latitude, this.longitude);
  }

  // getAddress(latitude, longitude) {
  //   this.geoCoder.geocode({ 'location': { lat: latitude, lng: longitude } }, (results, status) => {
  //     console.log(results);
  //     console.log(status);
  //     if (status === 'OK') {
  //       if (results[0]) {
  //         this.zoom = 12;
  //         this.address = results[0].formatted_address;
  //       } else {
  //         window.alert('No results found');
  //       }
  //     } else {
  //       window.alert('Geocoder failed due to: ' + status);
  //     }

  //   });
  // }

  checkLatlon(){
    const params = {
      'lat': this.latitude,
      'lon': this.longitude
    }
    console.log(params);
    
    
    this.rest.checkLatlon(params).subscribe((response:any) => {
      console.log(response);

      if ( response.status == false ) {
        alert(response.message + "\n\nTerimakasih!")
      }
    });
  }

  // onNext(content){
  onNext(){
    this.checkLatlon();
    this.submitted = true;

    if (this.registerForm.invalid) {
      return;
    }

    console.log(this.registerForm.value)


    this.rest.setDataprospek(this.registerForm.value).subscribe((response:any) => {
      console.log(response);

      if (response.status == true) {
        
        // Modal not work
        // this.modalService.open(content, {backdropClass: 'light-blue-backdrop', centered: true });
        // this.modalService.open(this.regis, {backdropClass: 'light-blue-backdrop', centered: true });

        alert(response.message + "\nMohon selanjutnya isi data diri dengan benar dan lengkap\n\nTerimakasih!")
        this.router.navigate(['regis2/', response.data.prospekindex]);

      } else {
        // console.log('not cover');
        alert(response.message + "\n\nTerimakasih!")
        // this.router.navigate(['regis/', id]);

      }
    });
  }

  onReset(){
    this.submitted = false;
    this.registerForm.reset();
  }

  // @ViewChild("mapContainer", { static: false }) gmap: ElementRef;
  // map: any;
  // lat = -6.184120;
  // lng = 106.831624;

  // markers = [
  //   {
  //     position: new google.maps.LatLng(40.73061, 73.935242),
  //     map: this.map,
  //     title: "Marker 1"
  //   },
  //   {
  //     position: new google.maps.LatLng(32.06485, 34.763226),
  //     map: this.map,
  //     title: "Marker 2"
  //   }
  // ];

  // //Coordinates to set the center of the map
  // coordinates = new google.maps.LatLng(this.lat, this.lng);

  // mapOptions: google.maps.MapOptions = {
  //   center: this.coordinates,
  //   zoom: 8
  // };

  // //Default Marker
  // marker = new google.maps.Marker({
  //   position: this.coordinates,
  //   map: this.map,
  //   title: "Hello World!"
  // });

  // ngAfterViewInit(): void {
  //   this.mapInitializer();
  // }

  // mapInitializer(): void {
  //   this.map = new google.maps.Map(this.gmap.nativeElement, this.mapOptions);

  //   //Adding Click event to default marker
  //   this.marker.addListener("click", () => {
  //     const infoWindow = new google.maps.InfoWindow({
  //       content: this.marker.getTitle()
  //     });
  //     infoWindow.open(this.marker.getMap(), this.marker);
  //   });

  //   //Adding default marker to map
  //   this.marker.setMap(this.map);

  //   //Adding other markers
  //   this.loadAllMarkers();
  // }

  // loadAllMarkers(): void {
  //   this.markers.forEach(markerInfo => {
  //     //Creating a new marker object
  //     const marker = new google.maps.Marker({
  //       ...markerInfo
  //     });

  //     //creating a new info window with markers info
  //     const infoWindow = new google.maps.InfoWindow({
  //       content: marker.getTitle()
  //     });

  //     //Add click event to open info window on marker
  //     marker.addListener("click", () => {
  //       infoWindow.open(marker.getMap(), marker);
  //     });

  //     //Adding marker to google map
  //     marker.setMap(this.map);
  //   });
  // }

  // ------- v2 -------
  // title: string = 'AGM project';
  // latitude: number;
  // longitude: number;
  // zoom:number;

  // // Get Current Location Coordinates
  // private setCurrentLocation() {
  //   if ('geolocation' in navigator) {
  //     navigator.geolocation.getCurrentPosition((position) => {
  //       this.latitude = position.coords.latitude;
  //       this.longitude = position.coords.longitude;
  //       this.zoom = 15;
  //     });
  //   }
  // }
}
